"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const axios_1 = __importDefault(require("axios"));
const BaseBuyProvider_1 = require("../BaseBuyProvider");
const ramp_png_1 = __importDefault(require("../../../../static/providers/ramp.png"));
// import CRYPTO_OPTIONS from "../../data/cryptoOptions";
// import { convertFiatRate } from "../../helpers/fiatRates";
const paymentMethods_1 = require("./paymentMethods");
// import { RAMP_API_KEY } from "../../data/apiKeys";
const constants_1 = require("./constants");
const fiatRates_1 = require("../../helpers/fiatRates");
/* const RAMP_POST_CONFIG = {
  headers: {
    "content-type": "application/json",
  },
  params: {
    hostApiKey: RAMP_API_KEY,
  },
}; */
class RampProvider {
    constructor() {
        this.id = "ramp";
        this.name = "Ramp";
        this.logo = ramp_png_1.default;
        this.addressPassthrough = true;
        this.defaultFiatCurrency = "USD";
        this.defaultCurrency = "EUR";
        this.countries = [];
        this.fiats = [];
        this.assets = [];
    }
    fetchCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${constants_1.RAMP_BASE_API}${constants_1.RAMP_API_ENDPOINTS.COUNTRIES}`;
                const { data } = yield axios_1.default.get(url);
                this.countries = data.map((c) => c.code.toUpperCase());
                this.fiats = data.reduce((p, c) => p.includes(c.mainCurrencyCode) ? p : [...p, c.mainCurrencyCode], []);
            }
            catch (error) {
                console.log("Error fetching Ramp countries", error);
            }
        });
    }
    fetchAssets() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${constants_1.RAMP_BASE_API}${constants_1.RAMP_API_ENDPOINTS.ONRAMP_ASSETS_V3}`;
                const { data } = yield axios_1.default.get(url);
                this.assets = data.assets.reduce((p, c) => c.type === "NATIVE" || (c.chain === "ETHERUM" && c.type === "ERC20")
                    ? [...p, c.symbol]
                    : p, []);
            }
            catch (error) {
                console.log("Error fetching Ramp assets", error);
            }
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            return Object.values(paymentMethods_1.paymentMethodsMap);
        });
    }
    getAvailability(countryData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!countryData)
                return false;
            if (this.countries.length === 0) {
                yield this.fetchCountries();
            }
            return this.countries.includes(countryData.alpha2.toUpperCase());
        });
    }
    getSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.assets.length === 0) {
                yield this.fetchAssets();
            }
            return this.assets;
        });
    }
    getSupportedFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.fiats.length === 0) {
                yield this.fetchCountries();
            }
            return this.fiats;
        });
    }
    getSupportedCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (this.countries.length !== 0) {
                    yield this.fetchCountries();
                }
                return this.countries;
            }
            catch (error) {
                console.log("Error getting Ramp countries", error);
                return this.countries;
            }
        });
    }
    getBuyQuote(cryptoCode, fiatCode, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const paymentOptions = yield this.getPaymentMethods();
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode.toUpperCase()
                    : this.defaultFiatCurrency;
                const convertedRate = isRequestedCurrency
                    ? fiatAmount
                    : Math.ceil(yield (0, fiatRates_1.convertFiatRate)(currencyCode, fiatCode, fiatAmount));
                const responseData = {
                    cryptoAmount: -1,
                    fiatAmount: convertedRate,
                    provider: this.id,
                    rate: -1,
                    isRequestedCurrency,
                    paymentOptions,
                    fiatCode: currencyCode,
                };
                return responseData;
            }
            catch (error) {
                console.log("Ramp Error", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
    getSellQuote(cryptoCode, fiatCode, cryptoAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // const url = `${RAMP_BASE_API}${RAMP_API_ENDPOINTS.OFFRAMP_QUOTE_V3}`;
                const supportedFiatCurrencies = yield this.getSupportedFiat();
                const isSupportedCurrency = supportedFiatCurrencies.includes(fiatCode);
                const currencyCode = isSupportedCurrency
                    ? fiatCode
                    : this.defaultCurrency;
                /* const convertedCrypto =
                  cryptoAmount * 10 ** CRYPTO_OPTIONS[cryptoCode].decimals; */
                /* const { data } = await axios.post<QuoteResult>(
                  url,
                  {
                    cryptoAssetSymbol: `${cryptoCode}_${CRYPTO_OPTIONS[
                      cryptoCode
                    ].network.toUpperCase()}`,
                    fiatCurrency: currencyCode,
                    cryptoAmount: convertedCrypto.toString(),
                  },
                  RAMP_POST_CONFIG
                ); */
                /* const {
                  asset: { price, maxPurchaseAmount, minPurchaseAmount },
                  ...paymentMethods
                } = data; */
                // if (!price) throw new Error("Problem getting quote");
                return {
                    provider: this.id,
                    cryptoAmount: -1,
                    fiatAmount: -1,
                    rate: -1,
                    isError: false,
                    isRequestedCurrency: isSupportedCurrency,
                    fiatCode: currencyCode,
                    // limits: { min: minPurchaseAmount, max: maxPurchaseAmount },
                };
            }
            catch (error) {
                console.log("Error getting Ramp sell quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
}
exports.default = RampProvider;
//# sourceMappingURL=Ramp.js.map